import angular from 'angular';
import _ from 'lodash';
import $ from 'jquery';

const uiServiceFactory = function UiServiceFactory($log, $http, $q, $rootScope, $timeout, NewBackendService, SocialProvisionsDaysFilter, StorageService, ValidazioneService) {
    'ngInject';
    const checkSocialProvisionsDaysFilter = function(daysNumber) {
      if (_.findIndex(SocialProvisionsDaysFilter.OPTIONS, function(o) {
          return o === daysNumber;
        }) > -1) {
        return daysNumber;
      } else {
        return SocialProvisionsDaysFilter.DEFAULT;
      }
    };

    return {
      checkSocialProvisionsDaysFilter,
      parseErrorMessage: function(errorMessage) {
        return errorMessage.slice(errorMessage.search('}') + 1);
      },
      getErrorMessagesMap: function() {
        const savedErrorsDate = StorageService.getLocalStorage('tinabaErrorDate');
        var param;
         
        if(savedErrorsDate != -1){
          param = 'locale=it&last-update='+savedErrorsDate;
        }else{
          param = 'locale=it'
        }
        
        
        NewBackendService.invokeWebApiGet(`/api/v2/errors/messages?${param}`, false).then((response) => {
          if (response && 'data' in response) { // controllo che ci sia effettivamente la tabella
            if (response.data.changed === false) {
              $log.debug('NewUiService', 'getErrorMessagesMap', 'Map hasn\'t changed');
            } else {
              StorageService.setLocalStorage('tinabaErrorDate', response.data.time);
              StorageService.setLocalStorageObject('tinabaErrorList', response.data.errors);
              $log.debug('NewUiService', 'getErrorMessagesMap', 'Map has been updated');
            }

            ValidazioneService.readMessageMap();
          } else { // se non c'è ritorno errore
            $log.error('NewUiService', 'getErrorMessagesMap', data);
          }
        }, (reason) => { // errore
          $log.error('NewUiService', 'getErrorMessagesMap', reason);
        });
      }
      /*getErrorMessagesMap: function() {
        const savedErrorsDate = StorageService.getLocalStorage('tinabaErrorDate');
        const savedErrorsReq = {
          data: {
            request: {
              getErrorsMessagesMapRequest: {
                locale: 'it'
              }
            }
          }
        };

        if (savedErrorsDate) {
          savedErrorsReq.data.request.getErrorsMessagesMapRequest.lastUpdate = savedErrorsDate;
        }

        NewBackendService.invokeWebApiPost('uxtextprovider/getErrorsMessagesMap', savedErrorsReq).then((data) => { // successo
          if (data && 'data' in data) { // controllo che ci sia effettivamente la tabella
            if (data.data.response.getErrorsMessagesMapResponse.changed === false) {
              $log.debug('NewUiService', 'getErrorMessagesMap', 'Map hasn\'t changed');
            } else {
              StorageService.setLocalStorage('tinabaErrorDate', data.data.response.getErrorsMessagesMapResponse.timestamp);
              StorageService.setLocalStorageObject('tinabaErrorList', data.data.response.getErrorsMessagesMapResponse.errorCodes);
              $log.debug('NewUiService', 'getErrorMessagesMap', 'Map has been updated');
            }

            ValidazioneService.readMessageMap();
          } else { // se non c'è ritorno errore
            $log.error('NewUiService', 'getErrorMessagesMap', data);
          }
        }, (reason) => { // errore
          $log.error('NewUiService', 'getErrorMessagesMap', reason);
        });
      }*/
    };
  }
export default uiServiceFactory;



/** WEBPACK FOOTER **
 ** ./client/app/common/services/tinaba-framework/ui.factory.js
 **/